<baxter-mfa-settings
  #mfaSettingsComponent
  (enableSetAuthenticatorAppEvent)="enableSetAuthenticatorApp()"
  (verifySoftwareTokenEvent)="verifySoftwareToken()"
  [setAuthenticatorApp]="setAuthenticatorApp"
  [mfaStatus]="true"
  [secretCode]="secretCode">
</baxter-mfa-settings>
